import { useEffect, useState, useCallback } from "react";
import { api } from "./api";

export function useRoomPolling(code, active) {
  const [room, setRoom] = useState(null);

  useEffect(() => {
    if (!active || !code) return;

    // Sprawdzamy lokalny stan połączenia PeerJS zamiast pytać serwer
    const timer = setInterval(() => {
      const currentState = api.getCurrentRoomState();
      if (currentState) {
        setRoom({ ...currentState, _fetchedAt: Date.now() });
      }
    }, 500);

    return () => clearInterval(timer);
  }, [active, code]);

  const patch = useCallback((r) => {
    setRoom(r);
    api.updateRoomState(r);
  }, []);

  return { room, setRoom: patch, refresh: () => {} };
}